import {z} from 'zod';

import {isNil} from 'ramda';

const OPAQUE_BUSINESS_CASE_CODE_SCHEMA = z.string().uuid();

export const toReadableBusinessCaseCode = (code: string | null): string | null =>
  isNil(code) || OPAQUE_BUSINESS_CASE_CODE_SCHEMA.safeParse(code).success ? null : code;
